<template>
  <div class="content">
    <msg-menu></msg-menu>

    <div class="d-block-create-msg" style="overflow: visible">
      <div class="container-fluid" :class="{'is-template': isTemplate}">
        <div class="row">
          <div class="col-md-6 col-sm-12 left-column">
            <h1 v-if="!isTemplate" class="page-title ">
              <span>Text Message</span>
              <span class="del-text">Send a text to your supporters</span>
            </h1>
            <h1 v-if="isTemplate && isNew" class="page-title">
              <span>Create a Template</span>
              <span class="del-text">Create and save templates to be used for future messages to your supporters</span>
            </h1>
            <h1 v-if="isTemplate && !isNew" class="page-title">Edit the Template</h1>

            <div v-if="!isTemplate" class="choose-recipients">
              <router-link :to="{name: 'lists'}" class="link-to-create-list">Need to Create a List?</router-link>
              <h3>Choose Recipients</h3>
              <div class="recipients">
                <select name="msg-recipients" id="msg-recipients" multiple></select>
              </div>
            </div>

            <div v-if="isTemplate" class="row">
              <div class="col-sm-6">
                <h3><label for="name-of-template">Template Name</label></h3>
                <input type="text"
                       class="input-sm "
                       id="name-of-template"
                       v-model="templateName"
                       placeholder="Name of Template">

              </div>
              <div class="col-sm-6">
                <h3><label for="template-select-folder">Add to a Folder</label></h3>
                <select class="input-sm" id="template-select-folder">
                  <option value="" placeholder>Select a Folder</option>
                </select>
              </div>
            </div>

            <div class="choose-text-message">
              <a href="#"
                 class="link-to-create-list"
                 v-on:click.prevent="isSelectTemplateModal = true">Start with a Template
              </a>
              <h3>Text Message</h3>

              <select-tags ref="selectTag"
                           v-on:txt-change="onTxtChange"
                           :block-id="'new-msg'"
              ></select-tags>

              <div class="upload-textarea-wrap upload-textarea-wrap-new-smg">

                <div class="dropdown-attach-to-msg dropdown-attach-to-msg-down">

                  <a class="btn btn-sm btn-sm-bold btn-attach dropbtn" data-dropdown=".select-actions" href="#"></a>

                  <add-attachment
                      :charity-info="activeCharityInfo"
                      v-on:select-attachment="selectAttachment"
                      v-bind:imageError.sync="imageError"
                      v-bind:imageIsLoading.sync="imageIsLoading"
                      v-bind:imageLoadingPercent.sync="imageLoadingPercent"
                  ></add-attachment>

                </div>
                <textarea name="new-msg" id="new-msg" class="new-msg" placeholder="Type a message..."></textarea>
                <button class="btn-icons btn-merge-tags" v-on:mousedown.prevent="$refs.selectTag.toggle()"></button>
              </div>

            </div>

            <input type="hidden" class="attach-link">
            <div class="row">
              <div class="col-xs-6">
                <div class="">
                  <h3 class="attachment-title">Attachment</h3>
                  <attachment-edit v-if="attachmentInfo && attachmentInfo.type !== 'none'"
                                   :attachment-info="attachmentInfo"
                                   :charity-info="activeCharityInfo"
                                   v-on:remove-attachment="attachmentInfo = null"
                  ></attachment-edit>
                  <div v-else class="none-attachment">
                    <a class="dropbtn" data-dropdown=".select-actions" href="#">+ Add an Attachment</a>
                  </div>
                </div>

                <div v-if="imageError" class="image-upload-error error-msg ">{{imageError}}</div>
                <div v-if="imageIsLoading" class="progress-big">
                  <div class="progress">
                    <div class="progress-val" :style="{'width': imageLoadingPercent + '%'}"></div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="text-right btn-wrap">
                  <a href="#" class="btn btn-sm btn-cancel" v-on:click.prevent="$router.go(-1)">Cancel</a>
                  <a href="#" v-if="!isTemplate" v-on:click.prevent="sendMessage" class="btn btn-sm">Send</a>
                  <a href="#" v-if="isTemplate" v-on:click.prevent="saveTemplate" class="btn btn-sm">Save</a>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6 col-sm-12 right-column">
            <div class="preview-msg clearfix">
              <div class="inner">
                <div class="wrap" v-if="activeCharityInfo">
                  <div class="ch-logo">
                    <img v-if="activeCharityInfo.logo_transparent"
                         :src="activeCharityInfo.logo_transparent"
                         :alt="activeCharityInfo.charity_name">
                  </div>
                  <div class="ch-name">{{activeCharityInfo.charity_name}}</div>
                </div>
                <div class="msg-text">{{previewText}}<span v-if="!previewText" class="placeholder">Preview of your message...</span>
                </div>

                <attachment v-if="attachmentInfo && attachmentInfo.type !== 'none'"
                            :attachment-info="attachmentInfo"
                            :charity-info="activeCharityInfo"
                            :is-loaded-media-wrap="false"
                ></attachment>
                <!--<div class="preview-img"></div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="isSelectTemplateModal"
           v-on:close-modal="isSelectTemplateModal = false"
           v-on:use-template="useTemplate"
           :charity-info="activeCharityInfo"
           :folders="[...folders]"
           :modal-name="'select-template'"></modal>
  </div>
</template>

<script>
  /*eslint-env jquery*/
  import {
    getFolders,
    editTemplate,
    createTemplate,
    getLists,
    sendMessageBulk,
    sendMessage, getAllCampaigns,
  } from '@/utils/api';
  import {prepareDonorName} from '@/utils/donors';
  import SelectTags from './select-tags.vue';
  import Modal from '../Modal/index.vue';
  import MsgMenu from './menu.vue';
  import AttachmentEdit from './attachment-edit.vue';
  import Attachment from './attachment.vue';
  import AddAttachment from './add-attachment.vue';
  import previewMixin from './preview-mixin';
  import useTemplatesMixin from './use-templates-mixin';
  import {mapState} from "vuex";

  export default {
    name: 'MessagesNew',
    components: {
      MsgMenu,
      Modal,
      AttachmentEdit,
      Attachment,
      AddAttachment,
      SelectTags,
    },
    props: [
      'isTemplate',
      'isNew',
    ],
    mixins: [previewMixin, useTemplatesMixin],
    metaInfo() {
      return {
        title: (this.isTemplate ? 'Templates' : 'Messages') + ' - ' + (this.isNew ? 'New' : 'Edit'),
      }
    },
    mounted() {
      const self = this;

      if (this.isTemplate) {
        // eslint-disable-next-line
        this.selectFolderChoices = new Choices(document.querySelector('#template-select-folder'), {
          searchEnabled: false,
          // placeholder: true,
          shouldSort: false,
          position: 'bottom',
          maxItemCount: 100,
          noChoicesText: '',
        });

      }
      else {//new message
        // eslint-disable-next-line
        this.multipleDefault = new Choices(document.getElementById('msg-recipients'), {
          placeholder: true,
          shouldSort: false,
          position: 'bottom',
          placeholderValue: 'Select a list or choose users…',
          maxItemCount: 100,
        });

        this.multipleDefault.passedElement.addEventListener('choice', e => {
          this.choiceUpdate(e.detail.choice.value);
        });

        getLists().then(lists => {
          this.lists = lists;
          this.listsLoaded = true;
        });
      }

      getFolders().then(folders => {
        this.folders = folders;

        if (this.selectFolderChoices) {
          this.selectFolderChoices.setChoices(
            folders.map(v => { return {value: v.id, label: v.name};}).concat([this.selectFolderChoices.getValue()]),
            'value', 'label', true,
          );
        }
      });

      //$('#new-msg').data('emojioneArea')
      $('#new-msg').emojioneArea({
        pickerPosition: 'right',
        filters: {
          symbols: {
            icon: 'heart',
          },
          flags: {
            icon: 'checkered_flag',
          },
        },
        events: {
          emojibtn_click: () => {
            $('.emojionearea').find('.emojionearea-button-close').click();
            self.onTxtChange();
          },
          change: () => self.onTxtChange(),
          keyup: () => self.onTxtChange(),
          paste: () => self.onTxtChange(),
        },
      });

      if (this.isTemplate && !this.isNew && this.$route.params.templateId) {
        this.useTemplate({id: this.$route.params.templateId});
      }
      else if (!this.isTemplate && this.$route.query.template_id) {
        this.useTemplate({id: this.$route.query.template_id});
      }
      else if ('body' in this.$route.query) {
        this.text = this.$route.query.body;
        $('#new-msg').data('emojioneArea').setText(this.text);
      }
    },
    methods: {
      selectAttachment(attachment) {
        this.imageError = '';
        this.attachmentInfo = attachment;
      },
      sendMessage() {

        let text = $('#new-msg').data('emojioneArea').getText().trim();

        if (text === '') {
          return false;
        }

        let message = {
          body: text,
        };

        if (this.attachmentInfo && this.attachmentInfo.type !== 'none') {
          // If the link is an image, send it as an attachment
          if (this.attachmentInfo.type === 'add-photo') {
            message.attachment = [this.attachmentInfo.link];
          }
          else {
            // Otherwise, prepend it to the message body.
            message.body = `${this.attachmentInfo.link}\n${message.body}`;
          }
        }

        let recipients = this.multipleDefault.getValue(true);
        let recipientsCount = 0;

        if (recipients.length === 0) {
          return false;
        }
        let query = {send_msg: ''};
        if (recipients[0] === 'all-donors') {
          sendMessageBulk(message, 'all');
          recipientsCount = this.multipleDefault.getValue()[0].customProperties.count;
        }
        else if (recipients[0] === 'active-donors') {
          sendMessageBulk(message, 'active');
          recipientsCount = this.multipleDefault.getValue()[0].customProperties.count;
        }
        else if (recipients[0] === 'inactive-donors') {
          sendMessageBulk(message, 'inactive');
          recipientsCount = this.multipleDefault.getValue()[0].customProperties.count;
        }
        else if (recipients[0].search('list_') !== -1) {
          let lid = recipients[0].replace('list_', '');

          sendMessageBulk(message, false, lid);
          recipientsCount = this.multipleDefault.getValue()[0].customProperties.count;
        }
        else if (recipients[0].search('campaign_') !== -1) {
          let campaignId = recipients[0].replace('campaign_', '');

          sendMessageBulk(message, false, false, campaignId);
          query.send_msg = `Your message has been sent to donors for <b>${this.multipleDefault.getValue()[0].customProperties.name}</b> who have text messages turned on`;
        }
        else {
          for (let i = 0; i < recipients.length; i++) {
            sendMessage(recipients[i], message);
          }

          /**
           * "Your Message has been sent to Jordan Patrick"
           * "Your message has been sent to 1 contact"
           */
          recipientsCount = recipients.length;
          if (recipientsCount === 1) {
            query.send_msg = `Your Message has been sent to ${this.multipleDefault.getValue()[0].customProperties.name}!`;
            query.thread_id = recipients[0];
          }
        }

        if (query.send_msg === '') {
          query.send_msg = `Your message has been sent to ${recipientsCount} contact${recipientsCount > 1 ? 's' : ''}!`;
        }

        this.$router.push({name: 'messages', query});

      },
      saveTemplate: function() {
        let text = $('#new-msg').data('emojioneArea').getText().trim();
        const folderId = this.selectFolderChoices.getValue(true);

        if (text === '') {
          $('#new-msg').data('emojioneArea').editor.focus();
          return false;
        }
        if (this.templateName === '') {
          document.getElementById('name-of-template').focus();
          return false;
        }
        if (!folderId) {
          alert('Select a Folder');
          return false;
        }

        let attachment = false;
        if (this.attachmentInfo && this.attachmentInfo.type !== 'none') {
          // If the link is an image, send it as an attachment
          if (this.attachmentInfo.type === 'add-photo') {
            attachment = this.attachmentInfo.link;
          }
          else {
            // Otherwise, prepend it to the message body.
            text = `${this.attachmentInfo.link}\n${text}`;
          }
        }

        if (!this.isNew) {
          editTemplate(this.templateName, text, this.$route.params.templateId, attachment, folderId).then(() => {
            this.$router.push({name: 'templates', query: {folder_id: folderId}});
          }).catch((err) => {
            alert(err.error);
          });
        }
        else {
          createTemplate(this.templateName, text, folderId, attachment).then(() => {
            this.$router.push({name: 'templates', query: {folder_id: folderId}});
          }).catch((err) => {
            alert(err.error);
          });
        }
      },
      onTxtChange() {
        this.text = $('#new-msg').data('emojioneArea').getText();
      },
      choiceUpdate(selVal) {
        this.multipleDefault.removeItemsByValue('inactive-donors');
        this.multipleDefault.removeItemsByValue('active-donors');
        this.multipleDefault.removeItemsByValue('all-donors');

        let toClear = this.multipleDefault.getValue(true);

        if (toClear.length > 0) {
          for (let i = 0; i < toClear.length; i++) {
            if (typeof toClear[i] === 'string' && toClear[i].search('list_') !== -1) {
              this.multipleDefault.removeItemsByValue(toClear[i]);
            }
          }
        }

        if (typeof selVal === 'string' &&
            (['all-donors', 'active-donors', 'inactive-donors'].indexOf(selVal) !== -1
            || selVal.search('list_') !== -1
            || selVal.search('campaign_') !== -1
          )
        ) {
          this.multipleDefault.removeActiveItems();
        }
      },
      initSelectRecipients: async function() {
        const donorsNotifications = this.donors.filter(v => {
          return v.sms_enabled;
        });

        let allCampaigns = await getAllCampaigns(true);

        allCampaigns = allCampaigns.filter(cmp => cmp.progress && cmp.progress.donors);

        let campaignsChoices = allCampaigns.map(cmp => {
          return {
            value: `campaign_${cmp.id}`,
            label: cmp.name,
            customProperties: {
              count: 1, name: cmp.name,
            },
          }
        });

        const activeCount = donorsNotifications.reduce((sum, v) => {
            return (v.status === 'complete') ? sum + 1 : sum;
          }, 0),
          inactiveCount = donorsNotifications.reduce((sum, v) => {
            return (v.status !== 'complete') ? sum + 1 : sum;
          }, 0);

        let donorsChoices = [];
        for (let i = 0; i < donorsNotifications.length; i++) {

          let oneDonor = donorsNotifications[i];
          donorsChoices.push({
            value: oneDonor.id.toString(),
            label: prepareDonorName(oneDonor),
            customProperties: {
              count: 1, name: prepareDonorName(oneDonor),
            },
          });
        }

        let autoGeneratedChoices = [
          {
            value: 'all-donors',
            label: `<span class="txt-blue">All Contacts</span><span class="donors-count">${activeCount +
            inactiveCount} people</span>`,
            customProperties: {count: activeCount + inactiveCount},
          },
          {
            value: 'active-donors',
            label: `<span class="txt-blue">ACTIVE Round-Up Donors</span><span class="donors-count">${activeCount} people</span>`,
            customProperties: {count: activeCount},
          },
          {
            value: 'inactive-donors',
            label: `<span class="txt-blue">INACTIVE Round-Up Donors</span><span class="donors-count">${inactiveCount} people</span>`,
            customProperties: {count: inactiveCount},
          },
        ];

        let listsChoices = [];

        for (let i = 0; i < this.lists.length; i++) {
          if (this.lists[i].member_count > 0) {
            listsChoices.push({
              value: 'list_' + this.lists[i].id,
              label: `<span class="txt-blue">${this.lists[i].name}</span><span class="donors-count">${this.lists[i].member_count} people</span>`,
              customProperties: {count: this.lists[i].member_count},
            });
          }
        }

        this.multipleDefault.setChoices([
          {
            label: 'Auto-generated segments',
            choices: autoGeneratedChoices,
          },
          {
            label: 'Choose a list',
            choices: listsChoices,
          },
          {
            label: 'Campaigns Donors',
            choices: campaignsChoices,
          },
          {
            label: 'Or select from contacts',
            choices: donorsChoices,
          },
        ], 'value', 'label', true);

        if (this.$route.query.list_id) {
          this.multipleDefault.removeActiveItems();
          this.multipleDefault.setValueByChoice('list_' + this.$route.query.list_id);
        }
        if (this.$route.query.campaign_id) {
          this.multipleDefault.removeActiveItems();
          this.multipleDefault.setValueByChoice('campaign_' + this.$route.query.campaign_id);
        }
        if (this.$route.query.donor_ids) {
          // For a single donor, `donor_ids` may be of a number type (meaning `.split()` method will not exist),
          // so cast it as a string here to avoid any errors. 
          const donorIds = this.$route.query.donor_ids.toString();

          let newMgsIds = donorIds.split(',').filter(v => !!v);
          if (newMgsIds.length > 0) {
            this.multipleDefault.removeActiveItems();
            this.multipleDefault.setValueByChoice(newMgsIds);
          }
        }

      },
    },
    watch: {
      'activeCharityId'() {
        this.$router.push({name: 'templates'});
      },
      'donorsState'() {
        if (this.listsLoaded && this.donorsState === 'ready') {
          this.initSelectRecipients();
        }
      },
      'listsLoaded'() {
        if (this.listsLoaded && this.donorsState === 'ready') {
          this.initSelectRecipients();
        }
      },
    },
    computed:{
      ...mapState({
        donors: state => state.donors.donors,
        donorsState: state => state.donors.donorsState,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
    },
    data() {
      return {
        text: '',
        templateName: '',
        isSelectTemplateModal: false,
        folders: [],
        selectFolderChoices: null,
        attachmentInfo: null,
        imageIsLoading: false,
        imageLoadingPercent: 0,
        imageError: '',

        multipleDefault: false,

        lists: [],
        listsLoaded: false,

      };
    },
  };
</script>

<style lang="sass">
  .d-block-create-msg
    position: static
    .msg-text
      white-space: pre-wrap
</style>
